import { render, staticRenderFns } from "./VideoControls.vue?vue&type=template&id=6d196d59&scoped=true&"
import script from "./VideoControls.vue?vue&type=script&lang=js&"
export * from "./VideoControls.vue?vue&type=script&lang=js&"
import style0 from "./VideoControls.vue?vue&type=style&index=0&id=6d196d59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d196d59",
  null
  
)

export default component.exports